import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CategoryEnum } from '../enums/category';
import { Environment, ENVIRONMENT } from '@classifieds-sell/environment';

@Injectable({
    providedIn: 'root'
})
export class CancelDraftService {
    constructor(
        private httpClient: HttpClient,
        @Inject(ENVIRONMENT) private env: Environment
    ) { }

    cancelDraft(
        categoryId: CategoryEnum,
        subCategory: string
    ): Observable<boolean> {
        return this.httpClient.delete<boolean>(
                subCategory ?
                `${this.env.apiUrl}/Draft/Category/${categoryId}/${subCategory}` :
                `${this.env.apiUrl}/Draft/Category/${categoryId}`,
            { withCredentials: true });
    }
}